import { gql } from "@apollo/client";

export const ON_REMOTE_SYNC_LOG_SUBSCRIPTION = gql`
  subscription OnRemoteSyncLog($employeeId: Int!) {
    remote_sync_log(where: { employee_id: { _eq: $employeeId } }, limit: 1) {
      id
      status
      log
      sync_results
      started_at
      completed_at
      updated_at
    }
  }
`;
